import { render, staticRenderFns } from "./NeedHelpToFindLeakageQuestion.vue?vue&type=template&id=40c6a240&scoped=true"
import script from "./NeedHelpToFindLeakageQuestion.vue?vue&type=script&lang=ts"
export * from "./NeedHelpToFindLeakageQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c6a240",
  null
  
)

export default component.exports